import React, { useState, useEffect } from 'react';
import Logo from './ui/Logo';

function ColdStartOverlay() {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsedSeconds((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const getStatusMessage = () => {
    if (elapsedSeconds < 15) return 'Waking up the server…';
    if (elapsedSeconds < 30) return 'Almost there. The server is starting…';
    if (elapsedSeconds < 45) return 'Taking longer than usual…';
    return 'Still starting…';
  };

  const getHintMessage = () => {
    if (elapsedSeconds < 30) {
      return 'Free-tier servers sleep after 15 minutes of inactivity.';
    }
    return 'If this keeps going, reload the page or check that the backend is running.';
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-pp-bg/80 animate-cold-start-fade-in"
      style={{ backdropFilter: 'blur(12px)' }}
      role="status"
      aria-live="polite"
      aria-label="Server is waking up"
    >
      <div className="pp-card flex w-[min(360px,calc(100vw-2rem))] flex-col items-center px-8 py-8 text-center shadow-modal">
        <Logo size={44} />

        {/* Status text — dynamic based on elapsed time */}
        <p className="mt-5 text-[15px] font-semibold text-pp-text">
          {getStatusMessage()}
        </p>
        <p className="mt-1 text-[13px] leading-relaxed text-pp-muted">
          {getHintMessage()}
        </p>

        {/* Indeterminate progress + elapsed time */}
        <div className="mt-5 h-1 w-full overflow-hidden rounded-full bg-pp-fill">
          <div className="h-full w-1/3 animate-cold-start-slide rounded-full bg-pp-accent" />
        </div>
        <span className="mt-3 text-2xs tabular-nums text-pp-faint">
          {elapsedSeconds}s
        </span>
      </div>
    </div>
  );
}

export default ColdStartOverlay;
